import type { NodeViewDecorator } from './../ricos-types';

import BoldDecorator from './bold/viewer';
import FontSizeDecorator from './font-size/viewer';
import ItalicDecorator from './italic/viewer';
import UnderlineDecorator from './underline/viewer';

export const nodeViewDecorators: NodeViewDecorator<JSX.Element>[] = [
  BoldDecorator,
  ItalicDecorator,
  UnderlineDecorator,
  FontSizeDecorator,
];
